export default "__VITE_ASSET__CmnF9d4o__"